import React from 'react';
import { Table, Space, Tag, Typography, Button, Empty } from 'antd';
import { 
  EditOutlined, 
  DeleteOutlined, 
  PhoneOutlined, 
  MailOutlined, 
  CheckCircleOutlined, 
  CloseCircleOutlined 
} from '@ant-design/icons';
import { Link } from 'react-router-dom';

const { Text } = Typography;

const DeliveryPersonList = ({ deliveryPersons, onDelete }) => {
  const columns = [
    {
      title: 'Nom',
      dataIndex: 'name',
      key: 'name',
      render: (text) => <Text strong>{text}</Text>,
    },
    {
      title: 'Contact',
      key: 'contact',
      render: (_, record) => (
        <Space direction="vertical" size="small">
          <Space>
            <PhoneOutlined />
            <Text>{record.phone}</Text>
          </Space>
          {record.email && (
            <Space>
              <MailOutlined />
              <Text>{record.email}</Text>
            </Space>
          )}
        </Space>
      ),
    },
    {
      title: 'Véhicule',
      key: 'vehicle',
      render: (_, record) => (
        <Space direction="vertical" size="small">
          <Text>{record.vehicle_description || '-'}</Text>
          {record.vehicle_plate && (
            <Text type="secondary">{record.vehicle_plate}</Text>
          )}
        </Space>
      ),
    },
    {
      title: 'Statut',
      key: 'status',
      render: (_, record) => (
        <Tag 
          icon={record.is_active ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
          color={record.is_active ? 'success' : 'default'}
        >
          {record.is_active ? 'Actif' : 'Inactif'}
        </Tag>
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      align: 'right',
      render: (_, record) => (
        <Space>
          <Link to={`/delivery-persons/${record.id}`}>
            <Button
              type="link"
              icon={<EditOutlined />}
            />
          </Link>
          <Button
            type="link"
            danger
            icon={<DeleteOutlined />}
            onClick={() => onDelete(record)}
          />
        </Space>
      ),
    },
  ];

  if (deliveryPersons.length === 0) {
    return <Empty description="Aucun livreur trouvé" />;
  }

  return (
    <Table
      columns={columns}
      dataSource={deliveryPersons.map(person => ({ ...person, key: person.id }))}
      pagination={{ pageSize: 10 }}
    />
  );
};

export default DeliveryPersonList; 